import { Box, Typography } from '@mui/material'
import React from 'react'
import MacrosNavigation from './MacrosNavigation'

export default function Macros() {
    return (
        <Box>
            <Box>
                <Typography variant='h4' align="center">
                    Major Economic Indicators
                </Typography>
            </Box>
            <MacrosNavigation />
        </Box>
    )
}
